var _module;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var MapifyMapStyles = /*#__PURE__*/function () {
  function MapifyMapStyles(L) {
    _classCallCheck(this, MapifyMapStyles);
    this.L = L;
    this.customStyles = {};
  }
  return _createClass(MapifyMapStyles, [{
    key: "add",
    value: function add(customStyles) {
      this.customStyles = _objectSpread(_objectSpread({}, this.customStyles), customStyles);
    }
  }, {
    key: "get",
    value: function get() {
      var styles = _objectSpread({
        'osm': new this.L.maplibreGL({
          style: 'https://tiles.mapifypro.com/api/maps/streets/style.json',
          attribution: '© <a target="_blank" href="https://openstreetmap.org/copyright">OpenStreetMap</a>',
          minZoom: 0,
          maxZoom: 19
        }),
        'mapifypro-basic': new this.L.maplibreGL({
          style: 'https://tiles.mapifypro.com/api/maps/basic/style.json',
          attribution: '© <a target="_blank" href="https://openstreetmap.org/copyright">OpenStreetMap</a>',
          minZoom: 0,
          maxZoom: 19
        }),
        'mapifypro-bright': new this.L.maplibreGL({
          style: 'https://tiles.mapifypro.com/api/maps/bright/style.json',
          attribution: '© <a target="_blank" href="https://openstreetmap.org/copyright">OpenStreetMap</a>',
          minZoom: 0,
          maxZoom: 19
        }),
        'mapifypro-streets': new this.L.maplibreGL({
          style: 'https://tiles.mapifypro.com/api/maps/streets/style.json',
          attribution: '© <a target="_blank" href="https://openstreetmap.org/copyright">OpenStreetMap</a>',
          minZoom: 0,
          maxZoom: 19
        }),
        'road': new this.L.TileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          minZoom: 2,
          maxZoom: 19,
          attribution: '© <a target="_blank" href="https://openstreetmap.org/copyright">OpenStreetMap</a>'
        }),
        'terrain': new this.L.TileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}', {
          minZoom: 2,
          maxZoom: 19,
          attribution: '© <a target="_blank" href="https://openstreetmap.org/copyright">OpenStreetMap</a>'
        }),
        'watercolor': new this.L.TileLayer('https://watercolormaps.collection.cooperhewitt.org/tile/watercolor/{z}/{x}/{y}.{ext}', {
          attribution: '© <a target="_blank" href="https://openstreetmap.org/copyright">OpenStreetMap</a>',
          minZoom: 2,
          maxZoom: 19,
          ext: 'jpg'
        }),
        'pastel': new this.L.TileLayer('https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png', {
          minZoom: 2,
          maxZoom: 19,
          attribution: '© <a target="_blank" href="https://openstreetmap.org/copyright">OpenStreetMap</a>'
        }),
        'esri-world-street-map': new this.L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}', {
          attribution: 'Tiles &copy; Esri &mdash; Source: Esri, DeLorme, NAVTEQ, USGS, Intermap, iPC, NRCAN, Esri Japan, METI, Esri China (Hong Kong), Esri (Thailand), TomTom, 2012',
          maxZoom: 16
        }),
        'esri-world-topo-map': new this.L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}', {
          attribution: 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ, TomTom, Intermap, iPC, USGS, FAO, NPS, NRCAN, GeoBase, Kadaster NL, Ordnance Survey, Esri Japan, METI, Esri China (Hong Kong), and the GIS User Community',
          maxZoom: 16
        }),
        'esri-world-imagery': new this.L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
          attribution: 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
          maxZoom: 16
        }),
        'esri-world-gray-canvas': new this.L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}', {
          attribution: 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ',
          maxZoom: 16
        })
      }, this.customStyles);
      return styles;
    }
  }]);
}();
/**
 * This is necessary because we are using this both in webpack and calling it directly from the frontend.
 * (ReferenceError: module is not defined)
 */
if (typeof module !== "undefined" && (_module = module) !== null && _module !== void 0 && _module.exports) {
  module.exports = MapifyMapStyles;
}